import {
  GET_PAYMENT_RESPONSE_LOADING,
  GET_PAYMENT_RESPONSE_SUCCESS,
  GET_PAYMENT_RESPONSE_FAILED,
} from '../types';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const paymentResponseReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_PAYMENT_RESPONSE_LOADING:
      return { ...state, loading: true, error: null };

    case GET_PAYMENT_RESPONSE_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case GET_PAYMENT_RESPONSE_FAILED:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
export default paymentResponseReducer;
